import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import {
  Modal,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

interface CommissionOfferModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function MembershipStatusModal({
  open,
  onClose,
  setOpen,
}: CommissionOfferModalProps) {
  const [membershipStatus, setMembershipStatus] = useState("Trial");

  return (
    <Modal className="modal membership_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Please update the status of Membership</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>

          <form className="form" action="">
            <FormControl fullWidth>
              <RadioGroup
                name="membership-radio-group"
                value={membershipStatus}
                onChange={(e) => setMembershipStatus(e.target.value)}
              >
                {/* Trial */}
                <div className="control_group">
                  <div className="lt">
                    <FormControlLabel
                      value="Trial"
                      control={<Radio />}
                      label="Trial"
                    />
                  </div>
                  <div className="rt">
                    <label>Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    className="form_control"
    slotProps={{
      textField: {
        fullWidth: true,
        placeholder: "Select",
        hiddenLabel: true,
      },
    }}
    desktopModeMediaQuery="(min-width:0px)"
  />
</LocalizationProvider>
                  </div>
                </div>

                {/* Complementary */}
                <div className="control_group">
                  <div className="lt">
                    <FormControlLabel
                      value="Complementary"
                      control={<Radio />}
                      label="Complementary"
                    />
                  </div>
                  <div className="rt">
                    <label>Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    className="form_control"
    slotProps={{
      textField: {
        fullWidth: true,
        placeholder: "Select",
        hiddenLabel: true,
      },
    }}
    desktopModeMediaQuery="(min-width:0px)"
  />
</LocalizationProvider>
                  </div>
                </div>

                {/* Paid */}
                <div className="control_group">
                  <div className="lt">
                    <FormControlLabel
                      value="Paid"
                      control={<Radio />}
                      label="Paid"
                    />
                  </div>
                  <div className="rt">
                    <label>Type</label>
                    <p>Solo</p>
                  </div>
                </div>
              </RadioGroup>
            </FormControl>

            <div className="footer_btn_flex justy_end">
           
              <Button
                className="btn btn_primary"
                onClick={() => {
                  console.log("Selected status:", membershipStatus);
                  setOpen(false);
                }}
              >
                Proceed
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
